import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t.marquee;

  const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 font-serif text-4xl font-light md:px-12 md:text-6xl ${
              i % 2 ? "italic text-olive/70" : "text-ink"
            }`}
          >
            {item}
          </span>
          <span className="h-2.5 w-2.5 rotate-45 bg-terra" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="marquee overflow-hidden border-y border-line bg-sand py-7 md:py-9" data-testid="marquee">
      <div className="marquee-track flex">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
